import React from "react";
import {
  Grid,
  GridColumn,
} from "@livingdesign/react";
import { getRejectionReason, renderTernary } from "../../../helpers/utils";
import { isValueEmptyCheck } from "../../../helpers/validationUtils";
import { amountFormat } from "../../../helpers/commonUtils";
import { APPROVING_ATTORNEY, DISCOUNT, MSR_CURRENT_STANDARD_RATE, MSR_JUSTIFICATION_FOR_RATE, MSR_PROPOSED_WALMART_RATE, RATE_STATUS_LABELS, REACH_TO_OCM, REJECTION_COMMENT, REJECTION_REASON, REQUESTER_EMAIL } from "../../../constants/constants";
import { useSelector } from "react-redux";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import { createUseStyles } from "react-jss";
import { SPACING } from "../../../constants/styleGuide";

const useStyles = createUseStyles({
	container: {
		width: "100vw",
		padding: "5px 20px"
	},
	contentSpacing16: {
    	paddingTop: SPACING.s16,
		fontSize: "14px",
  },
});
/**
 * This component is used to only edit matter specific rate.
 */
const ViewMatterPARateDetail = (props) => {
  const classes = useStyles();
  const masterDatas = useSelector(state => state?.masterData?.masterDatas);  
    const masterData = useSelector(state => state?.masterData);  


  const { rowData, fromMatterSpecificRates } = props;
  const colSpan = rowData?.length + 1;

  const displayData = (key, value) => {
		return <><strong>{key}:</strong> {value}</>;
	}

  return (
      <TableRow>
        <TableCell colspan={colSpan} className={classes.contentSpacing16}>
			{fromMatterSpecificRates && <div className={classes.contentSpacing16}><strong>{isValueEmptyCheck(rowData?.[14])}</strong></div>}
			<Grid>
				<GridColumn sm="6" md="6" lg="6">
					<div className={classes.contentSpacing16} data-testid="standard-rate">
						{displayData(MSR_CURRENT_STANDARD_RATE, renderTernary(rowData?.[6], `$${amountFormat(rowData?.[6])}/hr`, "-"))}
					</div>
					<div className={classes.contentSpacing16} data-testid="current-rate">
						{displayData(MSR_PROPOSED_WALMART_RATE, renderTernary(rowData?.[7], `$${amountFormat(rowData?.[7])}/hr`, "-"))}
					</div>
					<div className={classes.contentSpacing16} data-testid="discount">
						{displayData(DISCOUNT, rowData?.[8] ? `${rowData?.[8]}%` : '-')}
					</div>
				</GridColumn>
				<GridColumn sm="6" md="6" lg="6">
					<div className={classes.contentSpacing16} data-testid="approving-attorney">
						{displayData(APPROVING_ATTORNEY, isValueEmptyCheck(rowData?.[9]))}
					</div>
					<div className={classes.contentSpacing16} data-testid="requester-email">
						<Tooltip title={REACH_TO_OCM} placement="right">
							<span>{displayData(REQUESTER_EMAIL, isValueEmptyCheck(rowData?.[10]))} </span>
						</Tooltip>
					</div>
					<div className={classes.contentSpacing16} data-testid="justification">
						{displayData(MSR_JUSTIFICATION_FOR_RATE, isValueEmptyCheck(rowData?.[11]))}
					</div>
				</GridColumn>
				{rowData?.[4]?.props?.detail?.status === RATE_STATUS_LABELS.REJECTED &&
				<>
				<GridColumn sm="6" md="6" lg="6">
				<div className={classes.contentSpacing16} data-testid="rejection-reason">
					{displayData(REJECTION_REASON, getRejectionReason(rowData?.[12], masterDatas?.timekeeperRateRejectReason))}
				</div>
				</GridColumn>
				<GridColumn sm="6" md="6" lg="6">
				<div className={classes.contentSpacing16} data-testid="rejection-comment">
					{displayData(REJECTION_COMMENT, rowData?.[13] ? rowData?.[13] : "-")}
				</div>
				</GridColumn>
				</> }
			</Grid>
		</TableCell>
	</TableRow>     
  );
};

export default ViewMatterPARateDetail;
